export default __webpack_public_path__ + "static/media/replyTableIconDisabled.94316b03.svg";